var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C3.44667 8 2.92667 7.895 2.44 7.685C1.95333 7.475 1.53 7.19 1.17 6.83C0.81 6.47 0.525 6.04667 0.315 5.56C0.105 5.07333 0 4.55333 0 4C0 3.44667 0.105 2.92667 0.315 2.44C0.525 1.95333 0.81 1.53 1.17 1.17C1.53 0.81 1.95333 0.525 2.44 0.315C2.92667 0.105 3.44667 0 4 0C4.55333 0 5.07333 0.105 5.56 0.315C6.04667 0.525 6.47 0.81 6.83 1.17C7.19 1.53 7.475 1.95333 7.685 2.44C7.895 2.92667 8 3.44667 8 4C8 4.55333 7.895 5.07333 7.685 5.56C7.475 6.04667 7.19 6.47 6.83 6.83C6.47 7.19 6.04667 7.475 5.56 7.685C5.07333 7.895 4.55333 8 4 8ZM4 7.2C4.36 7.2 4.70667 7.14167 5.04 7.025C5.37333 6.90833 5.68 6.74 5.96 6.52L1.48 2.04C1.26 2.32 1.09167 2.62667 0.975 2.96C0.858333 3.29333 0.8 3.64 0.8 4C0.8 4.89333 1.11 5.65 1.73 6.27C2.35 6.89 3.10667 7.2 4 7.2ZM6.52 5.96C6.74 5.68 6.90833 5.37333 7.025 5.04C7.14167 4.70667 7.2 4.36 7.2 4C7.2 3.10667 6.89 2.35 6.27 1.73C5.65 1.11 4.89333 0.8 4 0.8C3.64 0.8 3.29333 0.858333 2.96 0.975C2.62667 1.09167 2.32 1.26 2.04 1.48L6.52 5.96Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCross);
export default __webpack_public_path__ + "static/media/grey_cross.148bd3601ee44a83f8a015839a38f21f.svg";
export { ForwardRef as ReactComponent };